import { ChannelBuckets } from '../../../context/ChatContext/buckets';

const channelConfiguration = {
  options: {
    state: true,
    watch: true,
    presence: true,
    limit: 20,
  },
  sort: (recentFirst) => {
    if (recentFirst) {
      return {
        has_unread: -1,
        last_message_at: -1,
        last_updated: -1,
      };
    }
    return {
      has_unread: -1,
      last_message_at: 1,
      last_updated: 1,
    };
  },
  filters: (userId, selectedBucket = ChannelBuckets.ACTIVE) => {
    const baseFilters = {
      type: 'messaging',
      members: { $in: [userId] },
    };
    if (selectedBucket === ChannelBuckets.ACTIVE) {
      return {
        ...baseFilters,
        hidden: false,
      };
    }
    if (selectedBucket === ChannelBuckets.ARCHIVED) {
      return {
        ...baseFilters,
        hidden: true,
        archived: true,
      };
    }
    return {
      ...baseFilters,
      $or: [{ hidden: true }, { hidden: false }],
    };
  },
  maxFileUploadLimit: 10,
};

export default channelConfiguration;
